module.exports = __webpack_public_path__ + "static/media/portfolio1 (25).d676e965.jpeg";